import { render, staticRenderFns } from "./GaugeChart.vue?vue&type=template&id=4a55b291&scoped=true"
import script from "./GaugeChart.vue?vue&type=script&lang=js"
export * from "./GaugeChart.vue?vue&type=script&lang=js"
import style0 from "./GaugeChart.vue?vue&type=style&index=0&id=4a55b291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a55b291",
  null
  
)

export default component.exports